// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2GZyf","inputDescription":"styles_inputDescription__Dh2fy"};